export const texts = {
  participants: {
    de: 'Teilnehmer',
    en: 'Participants'
  },
  inviteParticipant: {
    de: 'Teilnehmer einladen',
    en: 'Invite participant'
  },
  searchPlaceholder: {
    de: 'Name oder E-Mail',
    en: 'Name or email'
  },
  inviteNewParticipant: {
    de: 'Neuen Teilnehmer einladen',
    en: 'Invite new participant'
  },
  noUserFound: {
    de: 'Es wurde kein Benutzer gefunden. Bitte versuchen Sie es erneut oder geben Sie eine gültige E-Mail-Adresse an, um einen neuen Teilnehmer einzuladen.',
    en: 'No user was found. Please try again or enter a valid email address to invite a new participant.'
  },
  toOverview: {
    de: 'Zur Übersicht',
    en: 'Back to overview'
  },
  demoAccountTitle: {
    de: 'Demo-Konto',
    en: 'Demo account'
  },
  demoAccountBody: {
    de: 'Dein Konto ist ein Demo-Konto. Du kannst keine anderen Teilnehmer einladen.',
    en: 'Your account is a demo account. You cannot invite other participants.'
  },
  ok: {
    de: 'Ok',
    en: 'Ok'
  },
  userOfOtherCompany: {
    de: 'Diese Person ist einem anderen Unternehmen zugeordnet und kann deshalb nicht eingeladen werden. Bitte wende dich an den skillconomy-Support.',
    en: 'This person is assigned to another company and therefore cannot be invited. Please contact skillconomy support.'
  },
  addUserFailed: {
    de: 'Die Person konnte nicht hinzugefügt werden. Bitte versuche es erneut.',
    en: 'The person could not be added. Please try again.'
  },
  // as in sc-user-list
  projectManager: { de: 'Projektmanager', en: 'Project manager' },
  moderator: { de: 'Moderator', en: 'Moderator' },
  decider: { de: 'Entscheider', en: 'Decision-maker' },
  deciderModerator: { de: 'Entscheider & Moderator', en: 'Decision-maker & moderator' },
  notRegistered: { de: 'Nicht registriert', en: 'Not registered' },
  removeParticipant: { de: 'Teilnehmer entfernen', en: 'Remove participant' }
};
